import { Home } from "../../components/home/Home";

export const HomePage = () => {
    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center"
            }}
        >
            <Home />
        </div>
    );
}